import { classNames } from 'tradera/utils/class-names';
import React from 'react';
import { useTranslator } from 'tradera/lang/translate';

type NewTodayBadgeProps = {
    className?: string;
};

export const NewTodayBadge = ({ className }: NewTodayBadgeProps) => {
    const { t } = useTranslator();
    return (
        <span
            className={classNames(
                'badge badge-branded font-weight-bold',
                className
            )}>
            {t('itemCard_isNew')}
        </span>
    );
};
